import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import type { FC } from 'react';

import { WidgetCard } from './widget-card';

export const TrendingTagsWidgetSkeleton: FC = () => (
  <WidgetCard title="Trending Tags">
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
      {[72, 96, 64, 88, 76].map(width => (
        <Skeleton key={width} variant="rectangular" width={width} height={24} sx={{ borderRadius: '12px' }} />
      ))}
    </Box>
  </WidgetCard>
);
